// Enum for Add/Edit cell settings dialog mode
export const CellSettingsMode = Object.freeze({
    ADD: 'ADD',
    EDIT: 'EDIT',
    BULK_EDIT: 'BULK_EDIT'
});


